import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transforStringJson'
})
export class TransforStringJsonPipe implements PipeTransform {

  transform(value: any, ...args: any[]): void {
    let newValue: any;
    if (value && typeof value === 'object') {
      newValue = JSON.stringify(value);
      return newValue;
    }
  }
}
